var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"page-fade-transition-exit global-brand-bg",attrs:{"id":"main-wrap"}},[_c('v-main',[_c('nuxt')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }